import { Main } from "../../../components/main"

export const Publicacoes = () => {
  return (
    <Main>
      <section id="publications" className="services">
        <div className="container padding-top-bottom" data-aos="fade-up">
          <div className="section-title">
            <h2>Publicações</h2>
          </div>

          <div className="row mb-4">
            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <a target="_blank"
                href="https://drive.google.com/file/d/1yeHOuGIoofQpHrKajfWsiqjnOrnsf5Df/view?usp=share_link" rel="noreferrer">
                <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                  <div className="icon">
                    <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                  </div>
                  <h4>Publicação Taekwondo Em Ação I</h4>
                </div>
              </a>
            </div>

            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <a target="_blank" href="https://drive.google.com/file/d/1TH5eQFTIBzRo1LOo0nbWKJy8hQj8FEkh/view" rel="noreferrer">
                <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                  <div className="icon">
                    <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                  </div>
                  <h4>Publicação Taekwondo em Ação II</h4>
                </div>
              </a>
            </div>

            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <a target="_blank" href="https://drive.google.com/file/d/1zUGfP6XPXu1qob-zX3YKwkKtqZu98iu5/view" rel="noreferrer">
                <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                  <div className="icon">
                    <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                  </div>
                  <h4>Publicação Taekwondo Transformação</h4>
                </div>
              </a>
            </div>

            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <a target="_blank" href="https://drive.google.com/file/d/1c5GUgYnwc7XHRJ3Ska4hC-MNcrA7P5r8/view" rel="noreferrer">
                <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                  <div className="icon">
                    <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                  </div>
                  <h4>Retificação número do processo Taekwondo em Ação II</h4>
                </div>
              </a>
            </div>
            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <a target="_blank" href="https://drive.google.com/file/d/1sulF-9R9xvDhdyFmIytXftM2LgStR8tf/view" rel="noreferrer">
                <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                  <div className="icon">
                    <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                  </div>
                  <h4>Publicação Taekwondo Transformação II</h4>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </Main>
  )
}